import Cookies from 'js-cookie'
let tokenkey = 'zl-tokenD'
const Host = document.domain.split('.').slice(-2).join('.')
export function getToken () {
  return Cookies.get(tokenkey)
  // return Cookies.get(tokenkey,{domain:Host})
}
export function setToken (token) {
  // Cookies.set(tokenkey, token, {domain: Host, expires: 7 })
  Cookies.set(tokenkey, token)
}
export function removeToken () {
  Cookies.remove(tokenkey)
  // Cookies.remove(tokenkey,{domain: Host})
}
export function getQueryString (key) {
  let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
  let r = window.location.href.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}
export function GetRequest (name) {
  /**
         * 获取地址栏参数
         */
  let reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
  if (reg.test(window.location.href)) {
    return unescape(RegExp.$2.replace(/\+/g, ' '))
  }
  return null
}
export function GenNonDuplicateID () {
  return Math.random().toString(36).substr(3)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js